import { API_TYPES } from "@src/appV2/api/constants";
import { z } from "zod";

import { ESignWorkflowSessionStatus } from "./constants";

const esignProviderDataSchema = z.object({
  provider: z.string(),
  sessionId: z.string().optional(),
});

export const eSignWorkflowSessionAttributesSchema = z.object({
  signRequirementId: z.string(),
  compositeParentRequirementId: z.string().optional(),
  status: z.nativeEnum(ESignWorkflowSessionStatus),
  esignProviderData: esignProviderDataSchema.optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type ESignWorkflowSessionAttributes = z.infer<typeof eSignWorkflowSessionAttributesSchema>;

const eSignWorkflowSessionDataSchema = z.object({
  type: z.literal(API_TYPES.eSignWorkflowSession),
  id: z.string(),
  attributes: eSignWorkflowSessionAttributesSchema,
});

export const eSignWorkflowSessionResponseSchema = z.object({
  data: eSignWorkflowSessionDataSchema,
});

export type ESignWorkflowSessionResponse = z.infer<typeof eSignWorkflowSessionResponseSchema>;

export const eSignWorkflowSessionListResponseSchema = z.object({
  data: z.array(eSignWorkflowSessionDataSchema),
});

export type ESignWorkflowSessionListResponse = z.infer<
  typeof eSignWorkflowSessionListResponseSchema
>;
